import {
    CREATE_PLAY_HISTORY_SUCCESS,
    CREATE_PLAY_HISTORY_ERROR,
    CREATE_PLAY_HISTORY_REQUEST,

    CREATE_PLAY_VIEW_HISTORY_SUCCESS,
    CREATE_PLAY_VIEW_HISTORY_ERROR,
    CREATE_PLAY_VIEW_HISTORY_REQUEST,
    SET_CHAT_DOCUMENT

} from '../../Types/user/Types'


import { getPlay_HistoryAPI,getPlayView_HistoryAPI } from '../../Apis/user/ApiConfig'
import { id } from 'date-fns/locale';


export const create_play_history_success = (res) => {
    return {
      type: CREATE_PLAY_HISTORY_SUCCESS,
      payload: res,
    };
  };
  export const create_play_history_error = (error) => {
    return {
      type: CREATE_PLAY_HISTORY_ERROR,
      error: error,
    };
  };
  export const create_play_history_request = (res) => {
    return {
      type: CREATE_PLAY_HISTORY_REQUEST,
      payload: res,
    };
  };


  export const create_play_view_history_success = (res) => {
    return {
      type: CREATE_PLAY_VIEW_HISTORY_SUCCESS,
      payload: res,
    };
  };
  export const create_play_view_history_error = (error) => {
    return {
      type: CREATE_PLAY_VIEW_HISTORY_ERROR,
      error: error,
    };
  };
  export const create_play_view_history_request = (res) => {
    return {
      type: CREATE_PLAY_VIEW_HISTORY_REQUEST,
      payload: res,
    };
  };

  export const setChatDocument = (isChatDocument) => {
    return {
      type: SET_CHAT_DOCUMENT,
      payload: isChatDocument,
    };
  };





  export const create_play_history_actionHandler = ( page,search,field) => {
    return (dispatch) => {

      dispatch(create_play_history_request(page,search,field));
      
      try {
        getPlay_HistoryAPI(page,search,field)
          .then((res) => {
            if (res) {
              if (res && res?.data && res?.status === 200) {
                dispatch(create_play_history_success(res?.data));
              } else {
                let data = res?.response?.data?.data;
                dispatch(create_play_history_error(res));
              }
            } else {
              dispatch(create_play_history_error(""));
            }
          })
          .catch((err) => {
            dispatch(create_play_history_error("Something Went Wrong!!!"));
          });
      } catch (err) {
        dispatch(create_play_history_error(err));
      }
    };
  };


  export const create_play_view_history_actionHandler = (data,search, sortBy) => {
    return (dispatch) => {
      dispatch(create_play_view_history_request(data,search));
      try {
        getPlayView_HistoryAPI(data,search,sortBy)
          .then((res) => {
            if (res) {
              if (res && res?.data && res?.status === 200) {
                dispatch(create_play_view_history_success(res?.data));
              } else {
                let data = res?.response?.data?.data;
                dispatch(create_play_view_history_error(res));
              }
            } else {
              dispatch(create_play_view_history_error(""));
            }
          })
          .catch((err) => {
            dispatch(create_play_view_history_error("Something Went Wrong!!!"));
          });
      } catch (err) {
        dispatch(create_play_view_history_error(err));
      }
    };
  };